export function updateTheme(themeName) {
  document.querySelector("html").classList=themeName;
}
